import LineItems from '@apps/finance/admin/components/line_items'
import ContactToken from '@apps/crm/admin/tokens/contact'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    contact_id: PropTypes.number,
    line_items: PropTypes.array,
    program_id: PropTypes.number
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { contact_id, line_items, program_id } = this.props
    return {
      title: 't(New Invoice)',
      method: 'POST',
      action: '/api/admin/finance/invoices',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { name: 'program_id', type: 'hidden', value: program_id },
            ...contact_id ? [
              { name: 'contact_id', type: 'hidden', value: contact_id }
            ] : [
              { label: 't(Contact)', name: 'contact_id', type: 'lookup', endpoint: '/api/admin/crm/contacts', valueKey: 'id', textKey: 'display_name', required: true, format: ContactToken }
            ],
            { type: 'fields', fields: [
              { label: 't(Date)', name: 'date', type: 'datefield', placeholder: 'Date', required: true, defaultValue: moment() },
              { label: 't(Due)', name: 'due', type: 'datefield', placeholder: 'Date', required: true, defaultValue: moment().add(1, 'week') }
            ] },
            { label: 't(Line Items)', name: 'line_items', type: LineItems, required: true, defaultValue: line_items },
            { label: 't(Notes)', name: 'notes', type: 'textfield', placeholder: 'Add notes' }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(invoice) {
    this.context.router.push(`/finance/invoices/${invoice.id}`)
    this.context.modal.close()
  }

}

export default New
